import { render } from "./p_invitation.vue?vue&type=template&id=69616811&ts=true"
import script from "./p_invitation.vue?vue&type=script&lang=ts"
export * from "./p_invitation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__